import { IResourceContext, ResourceContextType } from '../model/base/annotation';

export const ROOT_RESOURCE_CONTEXT_DATA: IResourceContext = {
    contextId: '' + -1,
    contextType: 'root'
};

export const singleResourceContextDataFactory = (contextType: ResourceContextType) => ({
    contextId: 'SINGLE_RESOURCE_CONTEXT_ID',
    contextType
});
